const PrivacyPolicy = () => {
    const styles = {
        container: {
            maxWidth: '900px',
            margin: '0 auto',
            padding: '48px 24px',
            lineHeight: '1.6',
            color: '#333333',
            textAlign: 'left' as const,

        },
        header: {
            // textAlign: 'center' as const,
            marginBottom: '48px' as const,
        },
        title: {
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#000000',
            marginBottom: '16px'
        },
        subtitle: {
            fontSize: '18px'
        },
        bold: {
            fontWeight: '600'
        },
        italic: {
            fontStyle: 'italic',
            color: '#666666'
        },
        paragraph: {
            marginBottom: '24px',
            fontSize: '16px',
            color: '#333333'
        },
        h2: {
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '32px',
            marginBottom: '16px'
        },
        h3: {
            fontSize: '22px',
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '24px',
            marginBottom: '12px'
        },
        ul: {
            marginBottom: '24px',
            paddingLeft: '40px',
            listStyleType: 'disc'
        },
        li: {
            marginBottom: '8px',
            fontSize: '16px',
            color: '#333333'
        },
        link: {
            color: '#0066cc',
            textDecoration: 'underline'
        },
        contactSection: {
            marginBottom: '24px'
        },
        divider: {
            // textAlign: 'center' as const,
            marginTop: '48px',
            paddingTop: '32px',
            borderTop: '1px solid #cccccc'
        },
        asterisks: {
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#999999',
            marginBottom: '16px'
        },
        footer: {
            color: '#666666',
            fontStyle: 'italic'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={styles.title}>Privacy Policy</h1>
                <p style={styles.subtitle}>
                    <span style={styles.bold}>Prodigy Learning</span> | <span style={styles.italic}>Effective Date: November 6, 2025</span>
                </p>
            </div>

            <div>
                <p style={styles.paragraph}>
                    At Prodigy Learning (
                    <a href="https://www.prodigylearn.com" style={styles.link}>
                        https://www.prodigylearn.com
                    </a>
                    ), we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and express interest in visiting or enrolling in our schools.
                </p>

                <h2 style={styles.h2}>1. Information We Collect</h2>

                <h3 style={styles.h3}>1.1 Personal Information</h3>
                <p style={styles.paragraph}>
                    We collect personal information that you voluntarily provide to us when you express interest in visiting or enrolling in our schools. This information is used solely to contact you and facilitate your visit or enrollment. The personal information we collect may include:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Name</li>
                    <li style={styles.li}>Email address</li>
                    <li style={styles.li}>Phone number</li>
                    <li style={styles.li}>Any other information you choose to provide in your inquiry</li>
                </ul>
                <p style={styles.paragraph}>
                    We collect this information when you submit a contact form, request a school visit, or inquire about enrollment through our website.
                </p>

                <h3 style={styles.h3}>1.2 Usage Data</h3>
                <p style={styles.paragraph}>
                    We automatically collect certain technical information when you access our website, including:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>IP address</li>
                    <li style={styles.li}>Browser type and version</li>
                    <li style={styles.li}>Pages visited and time spent on pages</li>
                    <li style={styles.li}>Referring website addresses</li>
                </ul>

                <h3 style={styles.h3}>1.3 Cookies and Tracking Technologies</h3>
                <p style={styles.paragraph}>
                    We use cookies and similar tracking technologies to enhance your experience on our website and analyze usage patterns. You can control cookie preferences through your browser settings.
                </p>

                <h2 style={styles.h2}>2. How We Use Your Information</h2>
                <p style={styles.paragraph}>
                    We use the personal information we collect for the following specific purposes:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>To respond to your inquiries about visiting or enrolling in our schools</li>
                    <li style={styles.li}>To schedule and coordinate school visits</li>
                    <li style={styles.li}>To facilitate the enrollment process</li>
                    <li style={styles.li}>To provide you with information about our schools and programs</li>
                    <li style={styles.li}>To communicate with you regarding your visit or enrollment interest</li>
                    <li style={styles.li}>To improve our website and services</li>
                </ul>

                <h2 style={styles.h2}>3. How We Share Your Information</h2>
                <p style={styles.paragraph}>
                    We may share your personal information with third parties to help facilitate school visits and enrollment. This includes:
                </p>

                <h3 style={styles.h3}>3.1 Service Providers</h3>
                <p style={styles.paragraph}>
                    We may share your information with third-party service providers who assist us in operating our website, conducting our business, or facilitating your school visit or enrollment. These providers may include scheduling tools, communication platforms, enrollment management systems, and administrative services. These third parties are obligated to protect your information and use it only for the purposes we specify.
                </p>

                <h3 style={styles.h3}>3.2 School Partners</h3>
                <p style={styles.paragraph}>
                    We may share your information with the specific schools you have expressed interest in visiting or enrolling at, so they can directly contact you and coordinate your visit or enrollment process.
                </p>

                <h3 style={styles.h3}>3.3 Legal Requirements</h3>
                <p style={styles.paragraph}>
                    We may disclose your information if required to do so by law or in response to valid requests by public authorities, including to:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Comply with legal obligations, court orders, or government requests</li>
                    <li style={styles.li}>Protect and defend our rights or property</li>
                    <li style={styles.li}>Prevent or investigate possible wrongdoing</li>
                    <li style={styles.li}>Protect the safety of users or the public</li>
                </ul>

                <h3 style={styles.h3}>3.4 With Your Consent</h3>
                <p style={styles.paragraph}>
                    We may share your information for any other purpose with your consent or at your direction.
                </p>

                <p style={{...styles.paragraph, fontWeight: '600'}}>
                    We do not sell your personal information to third parties.
                </p>

                <h2 style={styles.h2}>4. Data Security</h2>
                <p style={styles.paragraph}>
                    We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>

                <h2 style={styles.h2}>5. Data Retention</h2>
                <p style={styles.paragraph}>
                    We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, or as required to facilitate your school visit or enrollment process. When your information is no longer needed, we will securely delete or anonymize it.
                </p>

                <h2 style={styles.h2}>6. Your Privacy Rights</h2>
                <p style={styles.paragraph}>
                    Depending on your location, you may have certain rights regarding your personal information:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}><span style={styles.bold}>Access:</span> Request access to the personal information we hold about you</li>
                    <li style={styles.li}><span style={styles.bold}>Correction:</span> Request correction of inaccurate or incomplete information</li>
                    <li style={styles.li}><span style={styles.bold}>Deletion:</span> Request deletion of your personal information</li>
                    <li style={styles.li}><span style={styles.bold}>Restriction:</span> Request restriction of processing of your information</li>
                    <li style={styles.li}><span style={styles.bold}>Objection:</span> Object to processing of your information for certain purposes</li>
                    <li style={styles.li}><span style={styles.bold}>Withdraw Consent:</span> Withdraw consent for processing where we rely on consent</li>
                </ul>
                <p style={styles.paragraph}>
                    To exercise these rights, please contact us using the information provided in the Contact Us section below. We will respond to your request within a reasonable timeframe and as required by applicable law.
                </p>

                <h2 style={styles.h2}>7. Children's Privacy</h2>
                <p style={styles.paragraph}>
                    While our schools may serve children, our website is directed to parents and guardians. We do not knowingly collect personal information directly from children under the age of 13 without parental consent. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately, and we will take steps to delete that information.
                </p>

                <h2 style={styles.h2}>8. International Data Transfers</h2>
                <p style={styles.paragraph}>
                    Your information may be transferred to and processed in countries other than your country of residence. These countries may have data protection laws that differ from those in your country. We take appropriate measures to ensure that your information receives an adequate level of protection wherever it is processed.
                </p>

                <h2 style={styles.h2}>9. Third-Party Links</h2>
                <p style={styles.paragraph}>
                    Our website may contain links to third-party websites or services that are not operated by us. We are not responsible for the privacy practices of these third parties. We encourage you to review the privacy policies of any third-party sites you visit.
                </p>

                <h2 style={styles.h2}>10. California Privacy Rights</h2>
                <p style={styles.paragraph}>
                    If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA):
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Right to know what personal information is collected, used, and shared</li>
                    <li style={styles.li}>Right to delete personal information held by businesses</li>
                    <li style={styles.li}>Right to opt-out of the sale of personal information</li>
                    <li style={styles.li}>Right to non-discrimination for exercising CCPA rights</li>
                </ul>
                <p style={styles.paragraph}>
                    <span style={styles.bold}>We do not sell your personal information.</span> To exercise your CCPA rights, please contact us using the information below.
                </p>

                <h2 style={styles.h2}>11. Changes to This Privacy Policy</h2>
                <p style={styles.paragraph}>
                    We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the effective date. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
                </p>

                <h2 style={styles.h2}>12. Contact Us</h2>
                <p style={styles.paragraph}>
                    If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
                </p>
                <div style={styles.contactSection}>
                    <p style={{...styles.paragraph, fontWeight: '600', marginBottom: '8px'}}>Prodigy Learning</p>
                    <p style={{...styles.paragraph, marginBottom: '8px'}}>
                        Website: <a href="https://www.prodigylearn.com" style={styles.link}>https://www.prodigylearn.com</a>
                    </p>
                    <p style={{...styles.paragraph, marginBottom: '8px'}}>Email: privacy@prodigylearn.com</p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;